export const BD_POSTAL_CODE_PLURALIZATION_MAPPING = {
    '=0': 'Keine Postleitzahl',
    '=1': '1 Postleitzahl',
    'other': '# Postleitzahlen'
};

export const BD_POSTAL_CODE_SUFFIX_PLURALIZATION_MAPPING = {
    '=1': 'Postleitzahl',
    'other': 'Postleitzahlen'
};

export class BdPostalCode {

    public static fromObjectArray(objArr: any[] = []): BdPostalCode[] {

        const mapObjects = (obj: any): BdPostalCode => {
            return BdPostalCode.fromObject(obj);
        };

        return objArr.map(mapObjects);
    }

    public static fromObject(obj: any = {}): BdPostalCode {
        return new BdPostalCode(
            obj.postalCode,
            obj.name,
            obj.otlName,
            obj.type,
            obj.administrativeDistrictId
        );
    }

    constructor(
        public postalCode: string,
        public name: string,
        public otlName: string,
        public type: string,
        public administrativeDistrictId: number
    ) {
    }

    public getDisplayName(): string {
        return `${this.postalCode} - ${this.name} ${this.otlName}`;
    }
}
